import React from "react";
import { Icon } from "../icon";
import getPillColor from "./colors";
var PillIcon = function (_a) {
    var icon = _a.icon, color = _a.color, hollow = _a.hollow, flavour = _a.flavour;
    if (!icon)
        return null;
    if (typeof icon !== "string")
        return icon;
    return (React.createElement(Icon, { width: "14px", height: "14px", name: icon, color: color ? color : hollow ? getPillColor("color", flavour) : "bright" }));
};
export default PillIcon;
